import type { IconData } from '@stacksjs/iconify-core'

export const gh1x1: IconData = {
  "body": "<path fill=\"#006b3f\" d=\"M0 0h512v512H0z\"/><path fill=\"#fcd116\" d=\"M0 0h512v341.3H0z\"/><path fill=\"#ce1126\" d=\"M0 0h512v170.7H0z\"/><path fill=\"#000001\" d=\"m256 170.7l55.5 170.6L166.3 236h179.4L200.6 341.3z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gh1x1
